import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import VideoForm from '../VideoForm';
import TermsOfService from '../TermsOfService';
import ConfirmAuthorization from '../ConfirmAuthorization';


class Step4 extends PureComponent {
  static propTypes = {
    season: PropTypes.object.isRequired,
    hexColorCodeC: PropTypes.string.isRequired,
    applicants: PropTypes.number.isRequired,
  };

  renderContent = () => {
    const { season } = this.props;
    if (this.props.applicants > 1) {
      return (
        <div className="ui bottom attached tab segment accented active">
          <VideoForm form="team" season={season} />
        </div>
      );
    }
    return (
      <div className="ui bottom attached tab segment accented active">
        <VideoForm form="member1" season={season} />
      </div>
    );
  };

  renderTabSections() {
    if (this.props.applicants > 1) {
      return (
        <div
          style={{ borderColor: `#${this.props.hexColorCodeC}` }}
          className="ui top attached tabular menu accented"
        >
          <div className="item active">Team</div>
        </div>
      );
    }
    return '';
  }

  render() {

    let privacyPolicy = require('../../assets/pdf/' + process.env.REACT_APP_PRIVACY);
    const IsGermanShoreShow = process.env.REACT_APP_IS_GERMAN_SHORE_SHOW === 'true';

    return (
      <div>
        {this.renderTabSections()}
        {this.renderContent()}
        <div style={{ marginBottom: '40px' }}>

          <TermsOfService form="termsOfServiceForm" />

          {IsGermanShoreShow ? (

            <ConfirmAuthorization form="confirmAuthorizationForm" />

            )
            :
            (

              <div>
                <p>
                  Mit dem Ausfüllen dieses Formulars erklären Sie sich damit einverstanden, dass alle Informationen (einschließlich personenbezogener Daten), die Sie uns zur Verfügung stellen, von Paramount und seinen verbundenen Unternehmen für die Zwecke der Kontaktaufnahme mit Ihnen (falls erforderlich), des Castings, der Beurteilung Ihrer Eignung für die Teilnahme an der Show, der Produktion der Show, der Aufnahme von Filmmaterial und der Ausstrahlung der Show über verschiedene Medien und deren Verwertung (falls zutreffend), einschließlich Fernsehen, digitale Medien und andere Plattformen (einschließlich sozialer und digitaler Plattformen) gemäß den Bedingungen unserer
                  {' '}
                  <a style={{ color: `#${this.props.hexColorCodeC}` }} href={privacyPolicy} target="_blank" rel="noopener noreferrer">
                    Datenschutzrichtlinie für die Produktion
                  </a>
                  {' '}
                  verarbeitet werden.
                </p>

                <p>
                  Sensible Daten: Es kann sein, dass wir zu den oben genannten Zwecken sensible personenbezogene Daten von Ihnen erheben müssen. Zu den sensiblen personenbezogenen Daten gehören Informationen über Ihre geistige Gesundheit, Ihre körperliche Fitness und Gesundheit, Ihr Sexualleben, Ihre sexuelle Orientierung, Ihre politischen Ansichten, Ihre Religion, Ihre Rasse, Ihre Genetik und Ihre biometrischen Daten.
                </p>

                <p>
                  <ConfirmAuthorization form="confirmAuthorizationForm" /> Darüber hinaus: Bitte bestätigen Sie, dass Sie uns ermächtigen, Ihre sensiblen personenbezogenen Daten zu den oben genannten Zwecken zu verarbeiten.  Weitere Informationen darüber, wie wir Ihre personenbezogenen Daten verwalten, finden Sie in unserer
                  {' '}
                  <a style={{ color: `#${this.props.hexColorCodeC}` }} href={privacyPolicy} target="_blank" rel="noopener noreferrer">
                    Datenschutzrichtlinie für die Produktion
                  </a>.
                </p>
              </div>

            )}

        </div>
      </div >
    );
  }
}

export default Step4;



// WEBPACK FOOTER //
// ./src/components/apply/Step4.js